/**
 * URL-hash keys for the handover-scanning feature's deep-linkable overlays,
 * bound via `useHashDialog` / `useHashParamDialog` (see `@/hooks/use-hash-dialog`).
 * Row-scoped overlays carry the entity id as a hash param (`#edit/5`).
 */
export const HANDOVER_SCANNING_HASH = {
  /** `#edit/<id>` — EditAssignmentDialog for a specific assignment. */
  edit: 'edit',
  /** `#delete/<id>` — single-assignment delete confirmation. */
  delete: 'delete',
  /** `#bulk-delete` — bulk delete confirmation (table action bar). */
  bulkDelete: 'bulk-delete'
} as const;

export type HandoverScanningHashKey =
  (typeof HANDOVER_SCANNING_HASH)[keyof typeof HANDOVER_SCANNING_HASH];
